import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import {
  allowedImageFormats,
  compressImage,
  isLargeScreen,
  sortArrayOfObject,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { DataCheckService } from '../../services/data-check.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MediaPreviewComponent } from '../media-preview/media-preview.component';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { firstValueFrom } from 'rxjs';
import { gTDB } from '../../services/db';

@Component({
  selector: 'gtapp-site-keys',
  templateUrl: './site-keys.component.html',
  styleUrl: './site-keys.component.scss',
  standalone: false,
})
export class SiteKeysComponent implements OnInit {
  largeView = isLargeScreen;
  // this should contains site id, company names and existing site keys
  @Input() selectedSite: any;
  @Input() showManageOption: boolean = true;
  @Output() updateSiteInfo = new EventEmitter();
  siteKeyList: any = [];

  isAdmin: boolean = this.dataCheckService.isUserAdmin();

  isDispatchUser: boolean = this.dataCheckService.isDispatchUser();

  newKeyData: any = {};

  dialogRef: any;
  searchStr: string = '';
  siteKeyFilteredList: any = [];

  masterKeySelectedSites: any = [];
  masterKeySelectedSiteIds: any = [];
  disabledSiteIds: any = [];

  // siteListData: any = [];

  siteFilterStringValue: string = '';
  siteFilteredList: any = [];

  // lastAddedSiteID: string = '';
  // totalSiteCount: number = 0;
  // siteAddedTimeoutFn: any;
  // sitePreviousCount: number = 0;
  // siteRowsCount: number = 20;
  // allSitesAdded: boolean = false;

  uiCachedSiteList: any = [];
  serverSiteList: any = [];
  serverSiteListResponseReturned: boolean = false;

  showSearchField = false;

  constructor(
    private dataCheckService: DataCheckService,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private appService: AppService,
    private clientService: ClientsService,
  ) {}
  ngOnInit(): void {
    if (this.selectedSite?.id) {
      this.getAllSiteKeys();
    }
  }
  getAllSiteKeys() {
    this.clientService
      .modifySiteKey(this.selectedSite?.id, {}, { get_all_site_keys: 1 })
      .then((resposne: any) => {
        if (resposne?.status === 'success') {
          this.siteKeyList = resposne?.data;
          this.updateSiteInfo.emit(this.siteKeyList);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: resposne?.message,
          });
        }
      });
  }
  openSiteKeysTemplate(template: any, siteKey?: any) {
    if (siteKey?.id) {
      this.newKeyData = {
        ...siteKey,
        multiple_sites: Boolean(siteKey?.master_key),
        master_key: Boolean(siteKey?.company_id),
      };
      const disabledSiteIds = new Set();

      if (siteKey?.master_key_uuid) {
        this.getMasterKeySites(siteKey?.master_key_uuid).then((res: any) => {
          this.masterKeySelectedSites = res || [];

          const currentSiteIndex = this.masterKeySelectedSites?.findIndex(
            (item: any) => item?.id == this.selectedSite?.id,
          );
          if (currentSiteIndex == -1) {
            // item not present
            this.masterKeySelectedSites = [
              this.selectedSite,
              ...this.masterKeySelectedSites,
            ];
            disabledSiteIds.add(this.selectedSite?.id);
            this.disabledSiteIds = [...disabledSiteIds];
          } else {
            const selectedSite = this.masterKeySelectedSites[currentSiteIndex];
            disabledSiteIds.add(selectedSite?.id);
            this.disabledSiteIds = [...disabledSiteIds];
          }
        });
      } else {
        this.masterKeySelectedSites = [this.selectedSite];
        disabledSiteIds.add(this.selectedSite?.id);
        this.disabledSiteIds = [...disabledSiteIds];
      }
    } else {
      this.newKeyData = {};
      this.masterKeySelectedSites = [{ ...this.selectedSite, disabled: true }];
    }
    this.getSelectedSiteIds();

    // this.siteListData = [];
    // this.sitePreviousCount = 0;

    this.getSiteList();

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  getSelectedSiteIds() {
    this.masterKeySelectedSiteIds = [
      ...new Set(this.masterKeySelectedSites?.map((site: any) => site?.id)),
    ];

    this.uiCachedSiteList.sort((a: any, b: any) => {
      const aSelected = this.masterKeySelectedSiteIds?.includes(a?.id) ? 1 : 0;
      const bSelected = this.masterKeySelectedSiteIds?.includes(b?.id) ? 1 : 0;

      if (aSelected !== bSelected) {
        return bSelected - aSelected;
      }

      return (a.company_name ?? '').localeCompare(b.company_name ?? '');
    });

    this.serverSiteList.sort((a: any, b: any) => {
      const aSelected = this.masterKeySelectedSiteIds?.includes(a?.id) ? 1 : 0;
      const bSelected = this.masterKeySelectedSiteIds?.includes(b?.id) ? 1 : 0;

      if (aSelected !== bSelected) {
        return bSelected - aSelected;
      }

      return (a.company_name ?? '').localeCompare(b.company_name ?? '');
    });
    // this.siteListData.sort((a: any, b: any) => {
    //   const aSelected = this.masterKeySelectedSiteIds?.includes(a?.id) ? 1 : 0;
    //   const bSelected = this.masterKeySelectedSiteIds?.includes(b?.id) ? 1 : 0;

    //   return aSelected - bSelected;
    // });
    // this.allSitesAdded = this.siteListData?.every((site: any) =>
    //   this.masterKeySelectedSiteIds?.includes(site?.id),
    // );
  }
  addAllsites() {
    // const remainingSites = this.siteListData?.filter(
    //   (site: any) => !this.masterKeySelectedSiteIds?.includes(site?.id),
    // );
    // remainingSites?.forEach((site: any) => {
    //   this.addSelectedSite(site);
    // });
  }
  getMasterKeySites(masterKey: string) {
    return new Promise((resolve: any) => {
      this.clientService
        .listSiteKeys({ master_key: masterKey, master_key_site_list: 1 })
        .then((res: any) => {
          resolve(res?.data || []);
        });
    });
  }
  async deleteSiteKey(siteKey: any) {
    let message = 'THIS ACTION CANNOT BE UNDONE!';
    let title = 'Delete Site Key';
    if (siteKey?.master_key) {
      title = 'Delete Master Key';
      if (siteKey?.company_id) {
        if (this.selectedSite?.company?.company_name) {
          message += `\n\n This key will be deleted from all sites belonging to ${this.selectedSite?.company?.company_name}`;
          title += ` for ${this.selectedSite?.company?.company_name}`;
        }
      } else if (siteKey?.master_key_uuid) {
        this.spinnerService.show();
        const siteList: any = await this.getMasterKeySites(
          siteKey?.master_key_uuid,
        );
        this.spinnerService.hide();
        if (siteList?.length) {
          message += `\n\n This key will be deleted from the following sites:`;
          message += `\n\n  • ${siteList?.map((item: any) => item?.company_name)?.join('\n  • ')}`;
        } else {
          message += '\n\n This key will be deleted from all sites';
        }
      } else {
        message += '\n\n This key will be deleted from all sites';
      }
    }

    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: title,
        message: message,
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.spinnerService.show('Updating Keys');
        this.clientService
          .modifySiteKey(
            this.selectedSite?.id,
            { key_id: siteKey?.id },
            { remove_site_key: 1 },
            true,
          )
          .then((resposne: any) => {
            if (resposne?.status === 'success') {
              this.siteKeyList = resposne?.data;
              this.spinnerService.hide();
              this.updateSiteInfo.emit(this.siteKeyList);
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: resposne?.message,
              });
            }
          });
      }
    });
  }

  selectFile() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  async fileCheck(fileExtension: string, fileSize: number) {
    let fileLimit: number = 1024 * 1024 * 8; // 8MB
    return new Promise((resolve) => {
      if (!allowedImageFormats.includes(fileExtension?.toLowerCase())) {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'Unsupported file format',
        });

        resolve(false);
      } else if (fileSize > fileLimit) {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'File Too Large ' + fileSize + ' / ' + fileLimit,
        });

        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
  async handleFileInput(event: any) {
    let file = event?.target?.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheck = await this.fileCheck(fileExtension, fileSize);
    if (fileCheck) {
      this.newKeyData.file = await compressImage(event?.target?.files.item(0));
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.newKeyData.file_url = event.target.result;
        this.spinnerService.hide();
      };
      this.spinnerService.show('Loading Image');
      reader.readAsDataURL(this.newKeyData.file);
    }
  }
  async deleteSitePhoto() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: '',
      },
    });
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
    if (dialogResponse !== true) return;
    if (this.newKeyData?.id) {
      this.spinnerService.show('Updating Key');
      let fileData: FormData = new FormData();
      let params: any = { remove_file: 1 };
      fileData.append('key_id', this.newKeyData?.id);
      this.appService
        .formDataApi(
          `site/${this.selectedSite?.id}/modify_site_key`,
          fileData,
          false,
          params,
        )
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });
            if (response?.data?.id) {
              this.siteKeyList.push(response?.data);
            } else {
              this.siteKeyList = response?.data || [];
            }

            this.dialogRef?.close();
            this.spinnerService.hide();
            this.updateSiteInfo.emit(this.siteKeyList);
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
        });
    } else {
      this.newKeyData.file = null;
      this.newKeyData.file_url = null;
    }
  }
  updateSiteKey() {
    this.spinnerService.show(
      this.newKeyData?.id ? 'Updating Site Key' : 'Adding Site Key',
    );
    let fileData: FormData = new FormData();
    let params: any = {};

    fileData.append('value', this.newKeyData?.value);
    if (this.newKeyData?.description)
      fileData.append('description', this.newKeyData?.description);
    if (this.newKeyData?.file) fileData.append('file', this.newKeyData?.file);
    if (this.newKeyData?.multiple_sites) {
      if (this.newKeyData?.master_key) {
        fileData.append('global_site_key', '1');
      } else if (this.masterKeySelectedSites?.length) {
        const siteIds = [
          ...new Set(
            this.masterKeySelectedSites
              ?.filter((item: any) => item?.id)
              ?.map((item: any) => item?.id),
          ),
        ];
        fileData.append('site_ids', JSON.stringify(siteIds));
      }
    }
    if (this.newKeyData?.id) {
      fileData.append('key_id', this.newKeyData?.id);
      params.update_site_key = 1;
    } else {
      params.add_site_key = 1;
    }

    this.appService
      .formDataApi(
        `site/${this.selectedSite?.id}/modify_site_key`,
        fileData,
        false,
        params,
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
          if (response?.data?.id) {
            this.siteKeyList.push(response?.data);
          } else {
            this.siteKeyList = response?.data || [];
          }

          this.dialogRef?.close();
          this.spinnerService.hide();
          this.updateSiteInfo.emit(this.siteKeyList);
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  onOpenFile(file: any) {
    this.dialogService.open(
      MediaPreviewComponent,
      {
        data: { mediaSrc: file?.file_url },
      },
      this.viewContainerRef,
    );
  }
  filterSiteKeys() {
    const searchStr = this.searchStr?.toLowerCase();
    this.siteKeyFilteredList = this.siteKeyList?.filter((item: any) =>
      typeof item === 'string'
        ? item?.toLowerCase()?.includes(searchStr)
        : item?.value?.toLowerCase()?.includes(searchStr) ||
          item?.description?.toLowerCase()?.includes(searchStr),
    );
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element.value = '';
      element?.focus();
    }, 100);
  }
  async getSitesFromServer() {
    let params: any = {
      company: this.selectedSite?.company?.id,
      rows: 1,
    };
    const response: any = await firstValueFrom(
      this.clientService.getSiteList(params),
    );
    if (response?.status != 'success') return [];
    if (response?.total_size == 1) return response?.data;
    params.rows = response?.total_size;
    const fullSiteListResponse: any = await firstValueFrom(
      this.clientService.getSiteList(params),
    );

    return fullSiteListResponse?.data || [];
  }
  async getSiteList() {
    this.serverSiteListResponseReturned = false;
    try {
      const record: any = await gTDB.cachedData
        .where('shortPath')
        .equals('/api/site/list_all_sites/')
        .first();
      const rawData: any[] = record?.data || [];
      this.uiCachedSiteList = rawData?.filter(
        (site: any) => site?.company?.id == this.selectedSite?.company?.id,
      );

      this.getSelectedSiteIds();
    } catch (error) {}

    this.serverSiteList = await this.getSitesFromServer();

    this.getSelectedSiteIds();
    this.serverSiteListResponseReturned = true;
    // let params: any = {
    //   company: this.selectedSite?.company?.id,
    //   rows: this.siteRowsCount,
    // };
    // if (this.sitePreviousCount) params.previous = this.sitePreviousCount;
    // if (this.siteFilterStringValue)
    //   params.search_str = this.siteFilterStringValue;
    // this.clientService.getSiteList(params).subscribe((res: any) => {
    //   if (res['status'] == 'success') {
    //     const alreadyPresentSiteIds = new Set(
    //       this.siteListData?.map((site: any) => site?.id),
    //     );
    //     (res?.data || [])?.forEach((site: any) => {
    //       if (!alreadyPresentSiteIds.has(site?.id))
    //         this.siteListData?.push(site);
    //     });
    //     this.totalSiteCount = res?.total_size || 0;
    //     this.getSelectedSiteIds();
    //   }
    // });
  }
  async openSiteSelectionTemplate(template: any) {
    const selectedItemsBackup = JSON.parse(
      JSON.stringify(this.masterKeySelectedSites),
    );
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    const dialogRefResponse = await firstValueFrom(dialogRef.afterClosed());
    if (!dialogRefResponse) {
      this.masterKeySelectedSites = JSON.parse(
        JSON.stringify(selectedItemsBackup),
      );
      this.getSelectedSiteIds();
    }
  }

  onSiteSearch(event: any) {
    const startsWithSearch = (field: string, searchStr: string) => {
      const regex = new RegExp(`\\b${searchStr}`, 'i');
      return regex?.test(field);
    };
    this.siteFilterStringValue = event.target.value;
    if (this.siteFilterStringValue)
      this.siteFilteredList = this.serverSiteList?.filter((site: any) =>
        startsWithSearch(
          site?.company_name,
          this.siteFilterStringValue?.toLowerCase(),
        ),
      );
    // if (this.siteFilterStringValue?.length > 2 || !this.siteFilterStringValue) {
    //   this.siteListData = [];
    //   this.sitePreviousCount = 0;
    //   this.getSiteList();
    // }
  }
  removeSelectedSite(selectedIndex: number) {
    // this.lastAddedSiteID = '';
    this.masterKeySelectedSites = this.masterKeySelectedSites?.filter(
      (_: any, index: number) => index !== selectedIndex,
    );
    this.getSelectedSiteIds();
  }
  updateSelectedSite(siteData: any) {
    if (this.disabledSiteIds?.includes?.(siteData?.id)) return;
    if (this.masterKeySelectedSiteIds?.includes?.(siteData?.id)) {
      this.masterKeySelectedSites = this.masterKeySelectedSites?.filter(
        (site: any) => site?.id != siteData?.id,
      );
    } else {
      this.masterKeySelectedSites.push(siteData);
    }
    this.getSelectedSiteIds();
  }

  addSelectedSite(selectedSite: any) {
    // this.lastAddedSiteID = '';

    if (this.masterKeySelectedSites?.length < 250) {
      this.masterKeySelectedSites.push(selectedSite);
      this.getSelectedSiteIds();

      // setTimeout(() => {
      //   this.lastAddedSiteID = selectedSite?.id;
      //   const lastElement: any = document.getElementById('lastElementAnchor');
      //   if (lastElement) {
      //     lastElement.scrollIntoView({
      //       behavior: 'smooth',
      //       block: 'end',
      //       inline: 'nearest',
      //     });
      //   }
      // }, 50);
      // if (this.siteAddedTimeoutFn) clearTimeout(this.siteAddedTimeoutFn);
      // this.siteAddedTimeoutFn = setTimeout(() => {
      //   this.lastAddedSiteID = '';
      // }, 1500);
    }
  }
}
